import React, { useState } from "react";
import { ArrowLeft, BookOpenText, CaseSensitive, Code2, SlidersHorizontal } from "lucide-react";
import { useHistory } from "react-router-dom";
import TabList from "./TabList";
import ParametersTableSection from "./ParametersTableSection";


const TABS = [
    { name: 'Parameters', icon: SlidersHorizontal, disabled: false },
]


function ParametersTabSection() {

    const history = useHistory();
    const [current, setCurrent] = useState(0);

    return (
        <div className="container-fluid">
            <button className="addrules-back-btn-v2" onClick={() => history.goBack()}>
                <ArrowLeft />
                Back
            </button>

            <div className="row">
                <div className="col-12">
                    <div className="addrules-grid-v2 parameters-page-layout-v2">
                        <div className="addrules-sidebar-v2">
                            <TabList tabs={TABS} current={current} setCurrent={setCurrent} />

                            <div className="addrules-info-card-v2 parameters-info-card-v2">
                                <h4 className="info-card-title">Usage Guide</h4>
                                <div className="info-card-list">
                                    <div className="addrules-info-item-v2">
                                        <Code2 />
                                        <div className="info-content">
                                            <span className="info-label">syntax</span>
                                            <span className="info-value parameters-usage-token-v2">$op&lt;Parameter Name&gt;</span>
                                        </div>
                                    </div>

                                    <div className="addrules-info-item-v2">
                                        <BookOpenText />
                                        <div className="info-content">
                                            <span className="info-label">where to use it</span>
                                            <span className="info-value">Rule scripts and condition expected output</span>
                                        </div>
                                    </div>

                                    <div className="addrules-info-item-v2">
                                        <CaseSensitive />
                                        <div className="info-content">
                                            <span className="info-label">important note</span>
                                            <span className="info-value">Parameter names and values are case sensitive</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ParametersTableSection />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default ParametersTabSection;
